export const settingsSidebarUsers = [
  {
    heading: 'Пользователи и роли',
    navlinks: {
      users: 'Пользователи',
      roles: 'Роли',
    },
  },
  {
    heading: 'Права',
    navlinks: {
      regions: 'Регионы',
      stations: 'Станции',
      privileges: 'Привилегии'
    },
  },
];
